var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portal"},[_c('app-header'),_c('main',{staticClass:"portal__main"},[_c('router-view')],1),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }